import { ApiResponse, getData } from "@Services/constServices";
import { API_V2 } from "@Models/GWDomain";

export const getCategoryClient = async (): Promise<ApiResponse> => {
  const url = `${API_V2}/marketing/customer-categories`;
  return getData(url);
};
